module.exports = __webpack_public_path__ + "img/左右翻转2.df119eb7.svg";